import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { ConfigurationBillableConceptGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/services/configuration-billable-concept-group.dto'
import { configurationBillableConceptGroupService } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/services/configuration-billable-concept-group.service'
import { ConfigurationBillableConceptResponse } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { store } from '@/store/store'

export const columnsDefBillableConceptGroupGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.groupOfConcepts'),
            field: 'name',
            minWidth: 250,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export enum ConceptGroupsGridSidepanelComboElements {
    CONCEPTS = 1
}

export interface BillableConceptGroupGridState extends CrudModelPaginatorLaboratory<ConfigurationBillableConceptGroupResponse> {
    service: typeof configurationBillableConceptGroupService
    laboratoryId: number
    showSidepanel: boolean
    sidepanelTitle: string
    selectedConcepts: ConfigurationBillableConceptResponse[]
}
export const initialBillableConceptGroupGridState =
    (): BillableConceptGroupGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.accounting.billableconceptgroup',
        columnsDef: columnsDefBillableConceptGroupGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationBillableConceptGroupService, store.getters.labId),
        service: configurationBillableConceptGroupService,
        laboratoryId: store.getters.labId,
        showSidepanel: false,
        sidepanelTitle: '',
        selectedConcepts: []
    })
